import React, { useContext, useState } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";
import DivisionProperties from "../PropertyComponents/DivisionProperties";
import ButtonProperties from "../PropertyComponents/ButtonProperties";
import ImageProperties from "../PropertyComponents/ImageProperties";
import HeaderProperties from "../PropertyComponents/HeaderProperties";
import ParagraphProperties from "../PropertyComponents/ParagraphProperties";
import IconProperties from "../PropertyComponents/IconProperties";
import LinkProperties from "../PropertyComponents/LinkProperties";
import CheckboxProperties from "../PropertyComponents/CheckboxProperties";
import ListProperties from "../PropertyComponents/ListProperties";
import RadioProperties from "../PropertyComponents/RadioProperties";
import TableProperties from "../PropertyComponents/TableProperties";
import TextProperties from "../PropertyComponents/TextProperties";
import VideoProperties from "../PropertyComponents/VideoProperties";
import RangeProperties from "../PropertyComponents/RangeProperties";
import PasswordProperties from "../PropertyComponents/PasswordProperties";
import EmailProperties from "../PropertyComponents/EmailProperties";
import NumberProperties from "../PropertyComponents/NumberProperties";
import DateProperties from "../PropertyComponents/DateProperties";
import ColorProperties from "../PropertyComponents/ColorProperties";
import FileProperties from "../PropertyComponents/FileProperties";
import AudioProperties from "../PropertyComponents/AudioProperties";
import DropdownProperties from "../PropertyComponents/DropDownProperties";
import MapProperties from "../PropertyComponents/MapProperties";
import NavProperties from "../PropertyComponents/NavProperties";
import HeaderTagProperties from "../PropertyComponents/HeaderTagProperties";
import HgroupProperties from "../PropertyComponents/HgroupProperties";
import FooterProperties from "../PropertyComponents/FooterProperties";
import SectionProperties from "../PropertyComponents/SectionProperties";
import SpanProperties from "../PropertyComponents/SpanProperties";
import FormComponentProperties from "../PropertyComponents/FormComponentProperties";
import MainProperties from "../PropertyComponents/MainProperties";
import ArticleProperties from "../PropertyComponents/ArticleProperties";
import AsideProperties from "../PropertyComponents/AsideProperties";
import HRtagProperties from "../PropertyComponents/HRtagProperties";
import BRTagnProperties from "../PropertyComponents/BRTagnProperties";
import OutputProperties from "../PropertyComponents/OutputProperties";
import IframeProperties from "../PropertyComponents/IframeProperties";

const RightSidebar = () => {
  const { selectedDivision, canvasDivisions, updateDivision } =
    useContext(CanvasContext);
  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (newValue === "true") {
      newValue = true;
    } else if (newValue === "false") {
      newValue = false;
    }

    if (selectedDivision !== null) {
      updateDivision(selectedDivision, { [name]: newValue });
    }
    console.log(
      `Division ${selectedDivision} updated with ${name}: ${newValue}`
    );
  };

  const handleLabelChange = (e) => {
    const { value } = e.target;
    if (selectedDivision !== null) {
      updateDivision(selectedDivision, { label: value });
    }
    console.log(`label updated to: ${value}`);
  };

  const handleTextChange = (e) => {
    const { value } = e.target;
    if (selectedDivision !== null) {
      updateDivision(selectedDivision, { text: value });
    }
    console.log(`Text updated to: ${value}`);
  };

  const handleItemUpload = (e, name) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (upload) => {
        if (selectedDivision !== null) {
          updateDivision(selectedDivision, { [name]: upload.target.result });
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const findDivisionById = (divs, id) => {
    for (let div of divs) {
      if (div.id === id) {
        return div;
      }
      if (div.children && div.children.length > 0) {
        const found = findDivisionById(div.children, id);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const selectedDiv =
    selectedDivision !== null
      ? findDivisionById(canvasDivisions, selectedDivision)
      : null;

  return (
    <div
      style={{
        minWidth: "15vw",
        width: "100%",
        height: "100%",
        padding: "3px",
        paddingTop: "0",
        border: "1px solid #ddd",
        overflow: "auto",
        backgroundColor: "#F9F9F9",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <h3 style={{ marginBlock: ".5rem", color: "#333", marginLeft: ".5rem" }}>
        ID:{selectedDivision} Properties
      </h3>
      <div style={{ backgroundColor: "#f9f9f9", position: "sticky", top: "0" }}>
        {selectedDiv !== null && (
          <input
            type="text"
            placeholder="Search properties..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 12px",
              marginBottom: "10px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              fontSize: "14px",
              boxShadow: "2px 2px 4px #000000",
              marginBlock: "5px",
              // padding: "5px",
              // marginBottom: "10px",
              // border: "1px solid #ccc",
            }}
          />
        )}
      </div>

      {selectedDiv !== null && selectedDiv.type === "DroppableDiv" && (
        <DivisionProperties
          selectedDiv={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}
      {selectedDiv !== null && selectedDiv.type === "DroppableMain" && (
        <MainProperties
          selectedMain={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}
      {selectedDiv !== null && selectedDiv.type === "DroppableArticle" && (
        <ArticleProperties
          selectedArticle={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}
      {selectedDiv !== null && selectedDiv.type === "DroppableAside" && (
        <AsideProperties
          selectedAside={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableButton" && (
        <ButtonProperties
          selectedDiv={selectedDiv}
          handleChange={handleChange}
          handleLabelChange={handleLabelChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableImage" && (
        <ImageProperties
          selectedImage={selectedDiv}
          handleChange={handleChange}
          handleImageUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableHeading" && (
        <HeaderProperties
          selectedDiv={selectedDiv}
          handleChange={handleChange}
          handleTextChange={handleTextChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableParagraph" && (
        <ParagraphProperties
          selectedDiv={selectedDiv}
          handleChange={handleChange}
          handleTextChange={handleTextChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableIcon" && (
        <IconProperties
          selectedIcon={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableLink" && (
        <LinkProperties
          selectedLink={selectedDiv}
          handleChange={handleChange}
          handleTextChange={handleTextChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableCheckbox" && (
        <CheckboxProperties
          selectedDiv={selectedDiv}
          handleChange={handleChange}
          handleLabelChange={handleLabelChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableRadio" && (
        <RadioProperties
          selectedRadio={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableList" && (
        <ListProperties
          selectedDiv={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableTable" && (
        <TableProperties
          selectedDiv={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableVideo" && (
        <VideoProperties
          selectedVideo={selectedDiv}
          handleChange={handleChange}
          handleVideoUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableTextInput" && (
        <TextProperties
          selectedText={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
          handleItemUpload={handleItemUpload}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableRangeInput" && (
        <RangeProperties
          selectedRange={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null &&
        selectedDiv.type === "DroppablePasswordInput" && (
          <PasswordProperties
            selectedPassword={selectedDiv}
            handleChange={handleChange}
            searchTerm={searchTerm}
            handleItemUpload={handleItemUpload}
          />
        )}

      {selectedDiv !== null && selectedDiv.type === "DroppableEmailInput" && (
        <EmailProperties
          selectedEmail={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableNumberInput" && (
        <NumberProperties
          selectedNumber={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableDateInput" && (
        <DateProperties
          selectedDate={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableColorInput" && (
        <ColorProperties
          selectedColor={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableFileInput" && (
        <FileProperties
          selectedFile={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableAudio" && (
        <AudioProperties
          selectedAudio={selectedDiv}
          handleChange={handleChange}
          handleAudioUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableDropDown" && (
        <DropdownProperties
          selectedDropdown={selectedDiv}
          handleChange={handleChange}
          handleOptionsChange={handleChange}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableMap" && (
        <MapProperties selectedMap={selectedDiv} handleChange={handleChange} />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableNav" && (
        <NavProperties
          selectedNav={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableHeader" && (
        <HeaderTagProperties
          selectedHeadertag={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableHGroup" && (
        <HgroupProperties
          selectedHgroup={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableFooter" && (
        <FooterProperties
          selectedFooter={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableSection" && (
        <SectionProperties
          selectedSection={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}

      {selectedDiv !== null && selectedDiv.type === "DroppableSpan" && (
        <SpanProperties
          selectedSpan={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}
      {selectedDiv !== null && selectedDiv.type === "DroppableForm" && (
        <FormComponentProperties
          selectedDiv={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}
      {selectedDiv !== null && selectedDiv.type === "DroppableOutput" && (
        <OutputProperties
          selectedoutput={selectedDiv}
          handleChange={handleChange}
          handleItemUpload={handleItemUpload}
          searchTerm={searchTerm}
        />
      )}
      {selectedDiv !== null && selectedDiv.type === "DroppableIframe" && (
        <IframeProperties
          selectedIframe={selectedDiv}
          handleChange={handleChange}
          searchTerm={searchTerm}
        />
      )}
      {selectedDiv !== null &&
        selectedDiv.type === "DroppableHorizontalRule" && (
          <HRtagProperties
            selectedDiv={selectedDiv}
            handleChange={handleChange}
            searchTerm={searchTerm}
          />
        )}

      {selectedDiv !== null && selectedDiv.type === "DroppableLineBreak" && (
        <BRTagnProperties />
      )}

      {selectedDiv === null && (
        <p>Please select a division to see its properties.</p>
      )}
    </div>
  );
};

export default RightSidebar;
